// AraAra — full-width world carousel. Auto-advances, swipe / arrows / dots.
class WorldCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-wc-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-wc-dot]'));
    if (this.slides.length === 0) return;
    this.index = 0;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.delay = Number(this.dataset.interval || 6000);

    this.querySelector('[data-wc-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-wc-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this._enableSwipe();

    this.show(0);
    this.start();
  }

  disconnectedCallback() { this.stop(); }

  show(i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((s, n) => s.toggleAttribute('data-active', n === this.index));
    this.dots.forEach((d, n) => d.toggleAttribute('data-active', n === this.index));
  }

  go(i) { this.show(i); this.restart(); }

  start() {
    if (this.reduce || this.slides.length < 2 || this._t) return;
    this._t = setInterval(() => this.show(this.index + 1), this.delay);
  }
  stop() { clearInterval(this._t); this._t = null; }
  restart() { this.stop(); this.start(); }

  _enableSwipe() {
    let x0 = null;
    this.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
    this.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }
}
if (!customElements.get('world-carousel')) customElements.define('world-carousel', WorldCarousel);
